import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {SearchPageBaseService} from "../../../search-page/service/search-page-base.service";
import {TextBoxComponent} from "../text-box/text-box.component";

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent  implements OnInit {

  @ViewChild('textBox', { static: true }) textBox!: TextBoxComponent;

  @Input() placeholder: string;
  @Input() searchTxtCtrl: FormControl;
  @Input() inputCallback: Function;
  @Output() onClickIcon = new EventEmitter();

  iconName: string = 'search';
  iconCallback: Function;

  constructor(private searchBaseService: SearchPageBaseService) { }

  ngOnInit() {

    this._initIcon();

    this.searchTxtCtrl.valueChanges.subscribe((value)=>{
      this._initIcon();
    });

  }

  focus() {
    this.textBox.focus();
  }

  private _initIcon(){
    this.iconCallback = this._resetTxt.bind(this);
    this.iconName = !!this.searchTxtCtrl.value ? 'close-outline': 'search';
  }

  private _resetTxt(){
    if(this.searchTxtCtrl.value){
      this.searchTxtCtrl.reset();
      this.searchBaseService.searchTxt = undefined;
      this.onClickIcon.emit();
    }
  }
}
